import Carousel, { CarouselSlide } from './Carousel';
import './Carousel.scss';

export type { CarouselSlide };
export default Carousel;